import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "video", "overlay" ]

  play() {
    this.videoTarget.play()
  }

  hideButton() {
    this.overlayTarget.classList.add("hidden")
  }

  showButton() {
    this.overlayTarget.classList.remove("hidden")
  }
}
